import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import Page from 'src/components/Page';

import Header from './Header';
import firebase from 'firebase/app';
import 'firebase/firestore';
import MaterialTable from 'material-table';
import { localization } from 'src/mixins/materialTable';
import genUrl from 'src/utils/genUrl';
const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  paginate: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
  },
}));

function Overview({ history }) {
  const classes = useStyles();

  const [cards, setCards] = useState([]);

  useEffect(() => {
    return firebase
      .firestore()
      .collection('cards')
      .where('status', '==', 'expired')
      .onSnapshot(snap => {
        const _cards = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCards([...cards, ..._cards]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page className={classes.root} title="Project Management List">
      <Container maxWidth={false}>
        <Header />

        <div className={classes.results}>
          <MaterialTable
            onRowClick={(_, { id }) => {
              const url = genUrl(history.location.pathname, id);
              history.push(url);
            }}
            localization={localization}
            options={{
              actionsColumnIndex: -1,
              showTitle: false,
              sorting: true,
            }}
            actions={[
              {
                icon: 'edit',
                onClick: (_, { id }) => {
                  const url = genUrl(history.location.pathname, id);
                  history.push(url);
                },
              },
            ]}
            columns={[
              { title: 'משתמש', field: 'user.displayName' },
              { title: 'שם העסק', field: 'businessName' },
              { title: 'תאריך תפוגת מנוי', field: 'validThrough' },
              { title: 'כמות צפיות', field: 'pageHits' },
            ]}
            data={cards}
          />
        </div>
      </Container>
    </Page>
  );
}

export default Overview;
